/**
 * Normalize Supabase/PostgREST errors so callers see friendly messages and can handle 404.
 * PGRST116 = 0 rows (e.g. .single() when no row found) -> "Not found" and status 404.
 */
const PGRST116 = 'PGRST116';

export interface NormalizedError extends Error {
  statusCode?: number;
}

export function normalizeSupabaseError(error: unknown): NormalizedError {
  if (error && typeof error === 'object' && 'code' in error) {
    const e = error as { code?: string; message?: string };
    if (e.code === PGRST116) {
      const err = new Error('Not found') as NormalizedError;
      err.statusCode = 404;
      return err;
    }
    return new Error(e.message || 'Something went wrong') as NormalizedError;
  }
  if (error instanceof Error) return error as NormalizedError;
  return new Error('Something went wrong') as NormalizedError;
}

/** Use after a Supabase call when you want to throw: if error is set, throw a friendly Error. */
export function throwIfSupabaseError(error: unknown): asserts error is null | undefined {
  if (error != null) throw normalizeSupabaseError(error);
}
